import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ScanLine } from 'lucide-react';
import CustomerLayout from '../../components/CustomerLayout';
import { CustomerPageHeading } from '../../components/customer/CustomerPageHeading';
import { QRReader } from '../../components/QRReader';
import { uiText } from '../../lib/i18n';
import { usePaymentResource } from '../../hooks/usePaymentResource';
import '../../styles/customer-payments.css';

export default function ScanRequestQRPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const config = usePaymentResource('/portal/payment-requests/config');
  const read = raw => {
    try {
      const url = new URL(raw.trim());
      const origins = [window.location.origin, new URL(process.env.REACT_APP_BACKEND_URL).origin, config.data?.publicOrigin];
      if (!origins.includes(url.origin) || url.protocol !== 'https:' || url.username || url.password || url.search || url.hash || !/^\/pay\/request\/[A-Za-z0-9_-]{43}$/.test(url.pathname)) throw new Error('invalid');
      navigate(url.pathname);
    } catch { setError('This is not a MALDHOWR Request Money QR.'); }
  };
  return <CustomerLayout><section className="payment-page-narrow" data-testid="scan-request-page"><CustomerPageHeading title="Scan Request QR" icon={ScanLine} testId="scan-request-heading" />
    {(error || config.error) && <p data-testid="scan-request-error" role="alert" className="customer-alert mb-5">{uiText(error || config.error)}</p>}
    <QRReader prefix="customer-request" onRead={read} busy={config.loading || !!config.error} />
  </section></CustomerLayout>;
}